// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import mergeReducer from "@toolkit/Framework/Common/Utilities/redux/mergeReducer";
import componentsReducer from "@store/Extensions/Store/Components/ComponentsReducer";

reducers.components = mergeReducer(reducers.components, componentsReducer);
